import React, { Component } from 'react';
import { Layout, Icon, Row, Col } from 'antd';
import { graphql, compose } from 'react-apollo';
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import { ViewField } from '../../common/view_field/view_field';
import { FIELDS, ROLES } from "./constants";
import { PhotoImage, PhotoPlaceholder } from "../../common/photoImage/photoImage";

import './profile.css';

const ProfileField = ({user, property, title, icon, bold, value}) =>
  FIELDS[user.type].includes(property) && (
    <ViewField title={title} icon={icon ? <Icon type={icon}/> : ""} className="profile-form__field">
      <span className={bold ? "bold" : ""}>{ value || user[property] }</span>
    </ViewField>
  );

class ProfileFields extends Component {
  render() {
    const { current_user } = this.props.data;
    const fields = FIELDS[this.props.data.current_user.type];

    return (
      <Layout className="profile-page__content">
        <Row>
          <Col lg={7} xl={6} xxl={3} xs={24} className="profile-page__photo-block">
            { this.props.data.current_user.photo.small ? <PhotoImage imageURL={this.props.data.current_user.photo.small}/> : <PhotoPlaceholder/> }
          </Col>
          <Col xs={{span: 20}} lg={{offset: 1, span: 10}}>
            <ProfileField user={current_user} property="email" title="Email (app username)" icon="mail" bold/>
            <ProfileField user={current_user} property="name" title="Name" icon="user" bold/>
            <ProfileField user={current_user} property="type" icon="book" value={ROLES[current_user.type]} bold/>
            <ProfileField user={current_user} property="department" title="Department" icon="solution" bold/>
            <ProfileField user={current_user} property="phone" title="Phone" icon="phone" bold/>
          </Col>
        </Row>
      </Layout>
    )
  }
}

export default compose(
  graphql(getCurrentUser)
)(ProfileFields);



// WEBPACK FOOTER //
// ./src/components/pages/profile/fields.js